import React from "react";
import { StandardPageWrapper } from "../../components/layout/StandardPageWrapper";
import { RequestInboxTabs } from "./RequestListingPage";
import { PageHeader } from "../../components/layout/header/Header";

export function RequestTutorialsPage() {
  return (
    <StandardPageWrapper fullWidth>
      <PageHeader titleContent="Request Inbox" />

      <div className="tw-boundary">
        <RequestInboxTabs selectedTabKey="tutorials" />

        <div className="grid grid-cols-3 gap-[48px] mt-[48px]">
          <TutorialCard />
          <TutorialCard />
          <TutorialCard />
          <TutorialCard />
          <TutorialCard />
          <TutorialCard />
        </div>
      </div>
    </StandardPageWrapper>
  );
}

function TutorialCard() {
  return (
    <div className="w-[343px] h-[301px] bg-white border-[1.5px] border-neutral-400 p-[32px] rounded-[8px] flex flex-col">
      <div className="w-[280px] h-[157px] bg-cool-gray-20 grid place-items-center rounded-[8px]">
        <svg
          width="97"
          height="97"
          viewBox="0 0 97 97"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M48.167 88.5029C26.075 88.5029 8.16699 70.5949 8.16699 48.5029C8.16699 26.4109 26.075 8.50293 48.167 8.50293C70.259 8.50293 88.167 26.4109 88.167 48.5029C88.167 70.5949 70.259 88.5029 48.167 88.5029ZM48.167 80.5029C56.6539 80.5029 64.7932 77.1315 70.7944 71.1303C76.7956 65.1292 80.167 56.9899 80.167 48.5029C80.167 40.016 76.7956 31.8767 70.7944 25.8755C64.7932 19.8743 56.6539 16.5029 48.167 16.5029C39.6801 16.5029 31.5407 19.8743 25.5396 25.8755C19.5384 31.8767 16.167 40.016 16.167 48.5029C16.167 56.9899 19.5384 65.1292 25.5396 71.1303C31.5407 77.1315 39.6801 80.5029 48.167 80.5029ZM64.671 55.4869L48.451 67.0789C44.831 69.6629 39.931 68.6349 37.503 64.7749C36.6267 63.3715 36.1637 61.7495 36.167 60.0949V36.9109C36.167 32.2709 39.699 28.5029 44.055 28.5029C45.619 28.5029 47.151 28.9989 48.451 29.9269L64.671 41.5189C68.291 44.1069 69.255 49.3269 66.831 53.1869C66.2673 54.0867 65.5336 54.8679 64.671 55.4869ZM44.055 36.9109V60.0949L60.275 48.5029L44.055 36.9109Z"
            fill="#C1C7CD"
          />
        </svg>
      </div>
      <div className="flex flex-col items-center">
        <div className="text-neutral-900 text-[18px] font-medium">
          A tutorial about this and that
        </div>
        <div className="text-neutral-600 text-[14px] font-normal">
          Watch this to learn more about this
        </div>
      </div>
    </div>
  );
}
